import React, { useEffect, useState } from "react";
import GLEqpSummaryTable from "./GlEqpSummaryTable";


function GlAhu() {

let imageParamsEqp = [
  {title: 'ON/OFF',parameter1 :'SAF_VFD_On_Off_Fbk',parameter2 :'CSU_Run_SS', unit:'', defaultValue:'', },
  {title: 'Trip Status',parameter1 :'SAF_VFD_Trip_SS_Alarm',parameter2 :'CSU_Trip_SS_Alarm', unit:'',minRange:'',maxRange:'', defaultValue:'Normal'},
  {title: 'Auto/Manual Status',parameter1 :'SAF_VFD_AM_Fbk',parameter2 :'CSU_Fan_AM_SS', unit:'', defaultValue:'', },
  {title: 'Supply Air Temp [℃]',parameter1 :'SAT',parameter2 :'CSU_SAT_Duct_Temp', unit:'℃',minRange:'11',maxRange:'18', defaultValue:'14'},
  {title: 'Return Air Temp [℃]',parameter1 :'RAT',parameter2 :'CSU_RAT', unit:'℃',minRange:'22',maxRange:'30', defaultValue:'24'},
  {title: 'Return Air RH [%]',parameter1 :'RARH',parameter2 :'CSU_RAH', unit:'%',minRange:'50',maxRange:'65', defaultValue:'55'},
  {title: 'Duct Static Pressure [bar]',parameter1 :'DSP',parameter2 :'CSU_Duct_pre', unit:'bar',minRange:'0',maxRange:'500', defaultValue:'200'},
  {title: 'FAN DPS',parameter1 :'SAF_VFD_On_Off_Fbk',parameter2 :'CSU_Run_SS', unit:'', defaultValue:'', },
  {title: 'Filter Status',parameter1 :'DPS_Filter',parameter2 :'CSU_Pre_Filter', unit:'',minRange:'',maxRange:'', defaultValue:'Normal'},
  {title: 'Heater Bank 1',parameter1 :'Heater_Bank_1_Status',parameter2 :'CSU_Heater_Bank_1_Status', unit:'',minRange:'',maxRange:'', defaultValue:''},
  {title: 'Heater Bank 2',parameter1 :'Heater_Bank_2_Status',parameter2 :'CSU_Heater_Bank_2_Status', unit:'',minRange:'',maxRange:'', defaultValue:''},
  {title: 'Heater Bank 3',parameter1 :'Heater_Bank_3_Status',parameter2 :'CSU_Heater_Bank_3_Status', unit:'',minRange:'',maxRange:'', defaultValue:''},
];

const ss_types = ["NONGL_SS_CSU", "NONGL_SS_AHU"]
return (
    <>
    <GLEqpSummaryTable 
    eqpSSTypes={ss_types} 
    imageParamsEqp={imageParamsEqp} />
    </>
  );
}

export default GlAhu;
